import React, { useEffect, useState } from "react";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import InputComponent from "../../../../components/Tenant/InputComponent/InputComponent";
import { toast } from "react-hot-toast";
import {
  useAddAppVideoMutation,
  useGetAppVideoTypesMutation,
  useGetAppVideoLanguageMutation
} from "../../../../features/tenant/appVideo/appVideoApi";
import { getVendorName } from "../../../../utils/getVendorName";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../../../utils/hasPermission";
import SelectComponent from "../../../../components/Tenant/SelectComponent/SelectComponent";
import TenantSlugs from "../../../../utils/TenantSlug";

const brandTypeOptions = [
  { id: 1, name: "LP" },
  { id: 2, name: "BD" },
];

const Video = () => {

  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [type, setType] = useState({
    name: "Please Select Type",
    id: -1,
  });

  const [language, setLanguage] = useState();
  const [link, setLink] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [brandType, setBrandType] = useState(null);

  const handleLinkChange = (event) => {
    const value = event.target.value;
    const isValidUrl =
      /^((https?|ftp):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}(\/.*)?$/.test(
        value
      );
    setLink(value);
    setIsValid(isValidUrl);
  };

  const [
    addVideo,
    {
      data: addAppVideoData,
      isLoading: addAppVideoIsLoading,
      isError: addAppVideoIsError,
      error: addAppVideoError,
    },
  ] = useAddAppVideoMutation();

  const [
    getAllVideoTypes,
    {
      data: getAllVideoTypesData,
      isLoading: getAllVideoTypesLoading,
      isError: getAllVideoTypesIsError,
      error: getAllVideoTypesError,
    },
  ] = useGetAppVideoTypesMutation();

  const [
    getAllVideoLanguages,
    {
      data: getAllVideoLanguagesData,
      isLoading: getAllVideoLanguagesLoading,
      isError: getAllVideoLanguagesIsError,
      error: getAllVideoLanguagesError,
    },
  ] = useGetAppVideoLanguageMutation();

  const getAllVideoTypesFun = () => {
    getAllVideoTypes({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  };

  const getAllVideoLangFun = () => {
    getAllVideoLanguages({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  };

  useEffect(() => {
    getAllVideoTypesFun();
    getAllVideoLangFun()
  }, []);


  const [dataArr, setDataArr] = useState([]);
  const [videoLangArr, setVideoLangArr] = useState([]);


  useEffect(() => {
    if (getAllVideoTypesData && getAllVideoTypesData.body) {
      setDataArr(getAllVideoTypesData?.body);
    }
  }, [getAllVideoTypesData, getAllVideoTypesError])

  useEffect(() => {
    if (getAllVideoLanguagesData && getAllVideoLanguagesData.body) {
      setVideoLangArr(getAllVideoLanguagesData?.body);
      setLanguage(getAllVideoLanguagesData?.body[0])
    }
  }, [getAllVideoLanguagesData, getAllVideoLanguagesError])


  const handleAddOption = (newItem) => {
    setDataArr([...dataArr, newItem]);
  };

  useEffect(() => {
    const hasViewPermission = hasPermission("video");
    if (!hasViewPermission) {
      navigate(`/genefied/${getVendorName()}/`);
    }

    if (addAppVideoData) {
      toast.success("Video Added !");
      navigate(`/genefied/${getVendorName()}/video`);
    }
  }, [addAppVideoData, addAppVideoError]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValidUrl =
      /^((https?|ftp):\/\/)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,}(\/.*)?$/.test(
        link
      );
    if (!title) {
      toast.error("Please provide a Title", {
        id: "imageError",
      });
      return;
    }

    if (!type.id == -1) {
      toast.error("Please provide a type", {
        id: "imageError",
      });
      return;
    }
    if (!link) {
      toast.error("Please provide a link", {
        id: "imageError",
      });
      return;
    } else if (title && type && link && !isValidUrl) {
      toast.error("Please provide a valid link", {
        id: "imageError",
      });
      return;
    }

    addVideo({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        type: type.name,
        link,
        title,
        language: language.name,
        ...(brandType?.name && { brand_type: brandType.name }),
      },
    });
  };
  return (
    <>
      {" "}
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Video
            <LinksComponent />
          </div>
          <div className="p-3">
            <form className="p-3 w-full bg-white shadow rounded-lg space-y-4">
              {/* First row: Title + Type */}
              <div className="grid grid-cols-2 gap-4">
                {/* Title */}
                <div>
                  <InputComponent
                    name="Title"
                    type="text"
                    value={title}
                    setValue={setTitle}
                    required
                    placeholder="Enter Title"
                  />
                </div>

                {/* Type */}
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-900">
                    Select Type*
                  </label>
                  {dataArr.length > 0 && (
                    <SelectComponent
                      selected={type}
                      setSelected={setType}
                      dataArr={dataArr}
                      allowDynamicAdd
                      onAddOption={handleAddOption}
                    />
                  )}
                </div>
              </div>

              {/* Second row: Language + Link */}
              <div className="grid grid-cols-2 gap-4">
                {/* Language */}
                {
                  [TenantSlugs.cavin, TenantSlugs.iffco].includes(JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id) ||
                  JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_name === "iffco" ? (
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900">
                        Select Language*
                      </label>
                      {videoLangArr.length > 0 && (
                        <SelectComponent
                          selected={language}
                          setSelected={setLanguage}
                          dataArr={videoLangArr}
                        />
                      )}
                    </div>
                  ) : null
                }

                {/* Link */}
                <div>
                  <label
                    htmlFor="link"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Link*
                  </label>
                  <input
                    id="link"
                    name="Link"
                    type="text"
                    value={link}
                    onChange={handleLinkChange}
                    required
                    placeholder="Paste Video link"
                    className="w-full shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
                  />
                  {!isValid && (
                    <p className="mt-1 text-sm text-red-600">Invalid URL</p>
                  )}
                </div>
              </div>

              {/* Branch - Lotus only */}
              {JSON.parse(sessionStorage.getItem("vendorData"))?.tenant_id == TenantSlugs.lotus && (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <SelectComponent
                      title={"Branch"}
                      selected={brandType}
                      setSelected={setBrandType}
                      dataArr={brandTypeOptions}
                      required={true}
                    />
                  </div>
                </div>
              )}

              {/* Submit button row */}
              <div className="flex justify-center mt-4">
                <button
                  type="submit"
                  onClick={(e) => handleSubmit(e)}
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </>
  );
};

export default Video;
